import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileTypeFilter'
})
export class FileTypeFilterPipe implements PipeTransform {

  transform(fileTypeCodeRes: any[],index:string): any[] {
    //console.log("Index in pipe ",index);
   // return fileTypeCodeRes.filter(a => (a.promotedDestination === index));
    console.log("Index in pipe ",index);
    if(index==="Internal"){
      index='I';
    }
    else if(index==="External"){
       index='E';
    }
    fileTypeCodeRes=fileTypeCodeRes.filter(a => (a.promotedDestination === index));
    let localFileTypeRes=[];
    fileTypeCodeRes.forEach((a) => localFileTypeRes.push(a.fileTypeCode));
   return localFileTypeRes;

 }

}
